export default __webpack_public_path__ + "static/media/hotei-greatest-hits.f6e38c42.webp";